module.exports = __webpack_public_path__ + "img/painter.5ff55db6.png";